/**
 * The agents the eval pages can be opened for: the landing cards, the sidebar's
 * agent switcher and the page titles. Ids are the runtime agent names recorded on
 * the collected traces; the evaluation APIs take them as ``?agent=`` and return
 * that agent's runs, sessions, evaluations, failed cases and home stats.
 */
export type EvalAgentId = "rocky" | "campaign_copilot_agent" | "marketing_agent" | "acquisition_agent";

export interface EvalAgent {
  id: EvalAgentId;
  label: string;
}

export const EVAL_AGENTS: EvalAgent[] = [
  { id: "rocky", label: "Rocky" },
  { id: "campaign_copilot_agent", label: "Campaign Copilot" },
  { id: "marketing_agent", label: "Marketing Agent" },
  { id: "acquisition_agent", label: "Acquisition Agent" },
];

export const DEFAULT_EVAL_AGENT = "rocky";

/** Display name of an agent id (the id itself when it is not listed). */
export function evalAgentLabel(id: string): string {
  return EVAL_AGENTS.find((a) => a.id === id)?.label ?? id;
}
